import React from 'react';

export default function MarketMasterbatchVisual({ accent, title, image }) {
  const file = image || 'market-01-flexible-packaging.png';
  const src = `${process.env.PUBLIC_URL || ''}/images/markets/${file}`;

  return (
    <div className="markets-v2__visual" data-accent={accent}>
      <img
        src={src}
        alt={`${title} — Auralux masterbatch application`}
        loading="lazy"
        decoding="async"
        width={1536}
        height={1024}
      />
      <span className="markets-v2__visual-sheen" aria-hidden="true" />
    </div>
  );
}
